export default __webpack_public_path__ + "static/media/2.048ed1a9.jpg";